export default __webpack_public_path__ + "static/resaam-ea4b0a913f791cf0c0a6e201611249ec.png";